import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthLocalities,
	GetHealthLocalitiesParams,
	GetHealthLocalitiesModel,
} from 'domain/usecases/private/booking-flow/health';

export class RemoteGetHealthLocalities implements GetHealthLocalities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthLocalitiesModel>,
	) {}

	async get({signal, ...params}: GetHealthLocalitiesParams): Promise<GetHealthLocalitiesModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
